var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"400px"},attrs:{"id":"map"}}),_c('div',[_c('p',[_vm._v("اضغط على الخريطة وضع المؤشر على العنوان الذي تريده")])])])
}]

export { render, staticRenderFns }